module.exports = __webpack_public_path__ + "img/OrderLpnPickingS1Page.b8b0e45c.png";